import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast } from "../../toast";

export const decrement_bonus_count: Action<Ctx, { id?: string }> = async (
  { sb },
  data,
  params,
) => {
  const user_id = data.id ?? params.get("id");
  if (!user_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }
  const { error } = await sb.functions.invoke(
    `api/users/${user_id}/bonus-count/decrement`,
    { method: "POST" },
  );
  if (error) {
    toast({ variant: "error", text: "Bonus update failed. Try again" });
    return { ok: false, error: error.message };
  }
  invalidate("users");
  toast({ variant: "success", text: "Bonus removed." });
  return { ok: true };
};
